import {
  CheckCircleFilled,
  CloseCircleFilled,
  ClockCircleOutlined,
} from "@ant-design/icons";
export const GuidEmpty = "00000000-0000-0000-0000-000000000000";

export const ROLE_ID = {
  Admin: 1,
  Agency: 2,
  Accountant: 3,
};
export const SYSTEM_ROLES = [
  { value: ROLE_ID.Admin, title: "Admin" },
  { value: ROLE_ID.Agency, title: "Điều hành" },
  { value: ROLE_ID.Accountant, title: "Kế toán" },
];

export const ORDER_FILTER_TIME_ID = {
  AllDay: 6,
  Today: 5,
  Yesterday: 1,
  ThisWeek: 2,
  ThisMonth: 3,
  LastMonth: 4,
};

export const ORDER_FILTER_TIME = [
  { value: ORDER_FILTER_TIME_ID.AllDay, title: "Tất cả ngày" },
  { value: ORDER_FILTER_TIME_ID.Today, title: "Hôm nay" },
  { value: ORDER_FILTER_TIME_ID.Yesterday, title: "Hôm qua" },
  { value: ORDER_FILTER_TIME_ID.ThisWeek, title: "Tuần này" },
  { value: ORDER_FILTER_TIME_ID.ThisMonth, title: "Tháng này" },
  { value: ORDER_FILTER_TIME_ID.LastMonth, title: "Tháng trước" },
];

export const STATUS_ORDER_ID = {
  FindingDriver: 1,
  FindingDriverRound: 2,
  DriverConfirming: 3,
  DriverConfirmed: 4,
  CustomerCanceled: 5,
  RequestTimeout: 6,
  DriverComeIn: 7,
  Started: 8,
  Completed: 9,
  DriverCancel: 10,
  OperatorCancel: 11,
};

export const STATUS_ORDER = [
  {
    value: STATUS_ORDER_ID.FindingDriver,
    title: "Đang tìm tài xế",
    className: "ant-tag-gold",
    color: "blue",
  },
  {
    value: STATUS_ORDER_ID.FindingDriverRound,
    title: "Tìm xe bán kính xa",
    className: "ant-tag-gold",
    color: "geekblue",
  },
  {
    value: STATUS_ORDER_ID.DriverConfirming,
    title: "Chờ tài xế xác nhận",
    className: "ant-tag-green",
    color: "yellow",
  },
  {
    value: STATUS_ORDER_ID.DriverConfirmed,
    title: "Tài xế đã xác nhận",
    className: "ant-tag-orange",
    color: "cyan",
  },
  {
    value: STATUS_ORDER_ID.CustomerCanceled,
    title: "Khách hàng hủy chuyến",
    className: "ant-tag-gold",
    color: "red",
  },
  {
    value: STATUS_ORDER_ID.RequestTimeout,
    title: "Không tìm thấy tài xế",
    className: "ant-tag-green",
    color: "orange",
  },
  {
    value: STATUS_ORDER_ID.DriverComeIn,
    title: "Tài xế đã đến",
    className: "ant-tag-orange",
    color: "lime",
  },
  {
    value: STATUS_ORDER_ID.Started,
    title: "Bắt đầu chuyến",
    className: "ant-tag-gold",
    color: "purple",
  },
  {
    value: STATUS_ORDER_ID.Completed,
    title: "Hoàn thành chuyến",
    className: "ant-tag-green",
    color: "green",
  },
  {
    value: STATUS_ORDER_ID.DriverCancel,
    title: "Tài xế hủy chuyến",
    className: "ant-tag-orange",
    color: "volcano",
  },
];

export const ORDER_TYPE_ID = {
  QuickOrder: 1,
  PointToPoint: 2,
  CityTour: 3,
  ExternalRequest: 4,
};

export const STATUS_ORDER_TYPE = [
  { value: ORDER_TYPE_ID.QuickOrder, title: "Gọi xe nhanh" },
  { value: ORDER_TYPE_ID.PointToPoint, title: "Có điểm đến" },
  { value: ORDER_TYPE_ID.CityTour, title: "City Tour" },
  { value: ORDER_TYPE_ID.ExternalRequest, title: "Yêu cầu bên ngoài" },
];

export const STATUS_DRIVER_ID = {
  Rest: 0,
  Active: 1,
  Inactive: 2,
};

export const STATUS_DRIVER = [
  { value: STATUS_DRIVER_ID.Active, title: "Hoạt động", color: "green" },
  { value: STATUS_DRIVER_ID.Rest, title: "Tạm nghỉ", color: "grey" },
  { value: STATUS_DRIVER_ID.Inactive, title: "Nghỉ việc", color: "red" },
];

export const STATUS_PARTNER_ID = {
  Registered: 0,
  PendingApprove: 1,
  Actived: 2,
  Deactive: 3,
};

export const STATUS_PARTNER = [
  { value: STATUS_PARTNER_ID.Registered, title: "Chờ xác nhận" },
  { value: STATUS_PARTNER_ID.PendingApprove, title: "Chờ duyệt" },
  { value: STATUS_PARTNER_ID.Actived, title: "Đã kích hoạt" },
  { value: STATUS_PARTNER_ID.Deactive, title: "Huỷ kích hoạt" },
];

export const STATUS_PRODUCT = [
  { value: 0, title: "Ngừng kinh doanh" },
  { value: 1, title: "Đang kinh doanh" },
];

export const STATUS_CUSTOMER_ID = {
  Inactive: true,
  Active: false,
};

export const STATUS_CUSTOMER = [
  { value: STATUS_CUSTOMER_ID.Active, title: "Hoạt động", color: "green" },
  { value: STATUS_CUSTOMER_ID.Inactive, title: "Bị chặn", color: "red" },
];

export const STATUS_EMPLOYEE_ID = {
  Active: 0,
  Inactive: 1,
};
export const STATUS_EMPLOYEE = [
  { value: STATUS_DRIVER_ID.Active, title: "Hoạt động", color: "green" },
  { value: STATUS_DRIVER_ID.Inactive, title: "Nghỉ việc", color: "red" },
];

export const STATUS_REVIEW_ID = {
  Inactive: 0,
  Active: 1,
};
export const STATUS_REVIEW = [
  { value: STATUS_REVIEW_ID.Inactive, title: "Ngưng sử dụng" },
  { value: STATUS_REVIEW_ID.Active, title: "Đang sử dụng" },
];

export const TYPE_REVIEW_ID = {
  Inactive: false,
  Active: true,
};
export const TYPE_REVIEW = [
  { value: TYPE_REVIEW_ID.Inactive, title: "Đánh giá tiêu cực" },
  { value: TYPE_REVIEW_ID.Active, title: "Đánh giá tích cực" },
];

export const STATUS_PRICE_ID = {
  Inactive: 0,
  Active: 1,
};
export const STATUS_PRICE = [
  { value: STATUS_PRICE_ID.Active, title: "Đang áp dụng", color: "green" },
  { value: STATUS_PRICE_ID.Inactive, title: "Ngưng áp dụng", color: "red" },
];

export const STATUS_VEHICLE_ID = {
  Available: 0, // Sẵn sàng
  OnTrip: 1, // Đang chạy
  UnderMaintenance: 2, // Bảo dưỡng
  Inactive: 3, // Ngừng hoạt động
};

export const STATUS_VEHICLE = [
  {
    value: STATUS_VEHICLE_ID.Available,
    title: "Sẵn sàng",
    color: "green",
  },
  {
    value: STATUS_VEHICLE_ID.OnTrip,
    title: "Đang chạy",
    color: "blue",
  },
  {
    value: STATUS_VEHICLE_ID.UnderMaintenance,
    title: "Bảo dưỡng",
    color: "orange",
  },
  {
    value: STATUS_VEHICLE_ID.Inactive,
    title: "Ngừng hoạt động",
    color: "red",
  },
];

export const STATUS_NEWS_ID = {
  Inactive: 0,
  Active: 1,
  Draft: 2,
};

export const STATUS_NEWS = [
  { value: STATUS_NEWS_ID.Active, title: "Đã xuất bản", color: "green" },
  { value: STATUS_NEWS_ID.Inactive, title: "Chưa xuất bản", color: "red" },
  { value: STATUS_NEWS_ID.Draft, title: "Bản nháp", color: "grey" },
];

export const STATUS_OTHER_SERVICE_ID = {
  Inactive: 0,
  Active: 1,
  Draft: 2,
};

export const STATUS_OTHER_SERVICE = [
  {
    value: STATUS_OTHER_SERVICE_ID.Active,
    title: "Đã xuất bản",
    color: "green",
  },
  {
    value: STATUS_OTHER_SERVICE_ID.Inactive,
    title: "Chưa xuất bản",
    color: "red",
  },
  { value: STATUS_OTHER_SERVICE_ID.Draft, title: "Bản nháp", color: "grey" },
];

export const STATUS_FAMOUS_PLACE_ID = {
  Inactive: 0,
  Active: 1,
};

export const STATUS_FAMOUS_PLACE = [
  {
    value: STATUS_FAMOUS_PLACE_ID.Active,
    title: "Trong vùng hoạt động",
    color: "green",
  },
  {
    value: STATUS_FAMOUS_PLACE_ID.Inactive,
    title: "Ngoài vùng hoạt động",
    color: "red",
  },
];

export const STATUS_PLACE_ID = {
  Inactive: false,
  Active: true,
};

export const STATUS_PLACE = [
  { value: STATUS_PLACE_ID.Active, title: "Công khai", color: "green" },
  { value: STATUS_PLACE_ID.Inactive, title: "Không công khai", color: "red" },
];

export const STATUS_CITY_TOUR_ID = {
  Inactive: 0,
  Active: 1,
  Draft: 2,
};
export const STATUS_CITY_TOUR = [
  { value: STATUS_CITY_TOUR_ID.Active, title: "Đang áp dụng", color: "green" },
  { value: STATUS_CITY_TOUR_ID.Inactive, title: "Ngưng áp dụng", color: "red" },
  { value: STATUS_CITY_TOUR_ID.Draft, title: "Bản nháp", color: "grey" },
];

export const GRID_ACTION_TYPE = {
  COPY_PRODUCT: "COPY_PRODUCT",
  GROUP_CATEGORY: "GROUP_CATEGORY",
  CHANGE_STATUS_PRODUCT: "CHANGE_STATUS_PRODUCT",
  DISCOUNT_PRODUCT: "DISCOUNT_PRODUCT",
  CHANGE_PRESTIGE_PARTNER: "CHANGE_PRESTIGE_PARTNER",
};

export const USER_GENDER = [
  { title: "Nam", value: 1 },
  { title: "Nữ", value: 2 },
  { title: "Giới tính khác", value: 0 },
];

export const PARTNER_PRESTIGE = [
  { value: 0, title: "Không uy tín" },
  { value: 1, title: "Uy tín" },
];

export const SYSTEM_STATUS_VOUCHER_ID = {
  Draft: 0, // Bản nháp
  AwaitingActivation: 1, // Chờ kích hoạt
  Active: 2, // Đang hoạt động
  Expired: 3, // Hết hạn
  SoldOut: 4, // Hết lượt (TotalLimit đã dùng hết) — THÊM MỚI
  Disabled: 5, // Đã tắt
};

export const SYSTEM_STATUS_VOUCHER = [
  {
    label: "Bản nháp",
    value: SYSTEM_STATUS_VOUCHER_ID.Draft,
    color: "#6b7280",
    bg: "#f3f4f6",
  },
  {
    label: "Chờ kích hoạt",
    value: SYSTEM_STATUS_VOUCHER_ID.AwaitingActivation,
    color: "#3e79f7",
    bg: "#eff6ff",
  },
  {
    label: "Đang hoạt động",
    value: SYSTEM_STATUS_VOUCHER_ID.Active,
    color: "#16a34a",
    bg: "#ecfdf5",
  },
  {
    label: "Hết hạn",
    value: SYSTEM_STATUS_VOUCHER_ID.Expired,
    color: "#6b7280",
    bg: "#f3f4f6",
  },
  {
    label: "Hết lượt",
    value: SYSTEM_STATUS_VOUCHER_ID.SoldOut,
    color: "#ff8a00",
    bg: "#fffbeb",
  },
  {
    label: "Đã tắt",
    value: SYSTEM_STATUS_VOUCHER_ID.Disabled,
    color: "#dc2626",
    bg: "#fef2f2",
  },
];

export const DISCOUNT_TYPE_OPTION = {
  FixedAmount: 1,
  Percent: 2,
  Gift: 3,
};

export const DISCOUNT_TYPE = [
  {
    label: "Giảm theo phần trăm",
    value: DISCOUNT_TYPE_OPTION.Percent,
    color: "green",
  },
  {
    label: "Giảm theo số tiền cố định",
    value: DISCOUNT_TYPE_OPTION.FixedAmount,
    color: "blue",
  },
  { label: "Tặng dịch vụ", value: DISCOUNT_TYPE_OPTION.Gift, color: "orange" },
];

export const SYSTEM_STATUS_SHIFTS_ID = {
  Shifted: 1,
  NotShift: 2,
  // NotShift1: 2,
  // NotShift2: 3,
};
export const SYSTEM_FILTER_SHIFTS_ID = {
  Bold: 3,
  Shift1: 1,
  Shift2: 2,
};
export const SYSTEM_STATUS_SHIFTS_DRIVER_ID = {
  Shifted: 0,
  NotShift: 1,
};

export const SYSTEM_STATUS_DRIVER = [
  {
    name: "Đã phân Xe",
    id: SYSTEM_STATUS_SHIFTS_ID.Shifted,
    className: "ant-tag-green",
  },
  {
    name: "Chưa phân xe",
    id: SYSTEM_STATUS_SHIFTS_ID.NotShift,
    className: "ant-tag-red",
  },
  // { name: 'Chưa phân ca 1', id: SYSTEM_STATUS_SHIFTS_ID.NotShift1, className: "ant-tag-red"  },
  // { name: 'Chưa phân ca 2', id: SYSTEM_STATUS_SHIFTS_ID.NotShift2, className: "ant-tag-red"  },
];

export const listYear = [
  { value: 2023, name: "2023" },
  { value: 2024, name: "2024" },
  { value: 2025, name: "2025" },
  { value: 2026, name: "2026" },
  { value: 2026, name: "2027" },
  { value: 2026, name: "2028" },
  { value: 2026, name: "2029" },
  { value: 2026, name: "2030" },
];

export const STATUS_WARNING_ID = {
  UnHandle: 0,
  Handled: 1,
};
export const STATUS_WARNING = [
  { name: "Xử lý", id: STATUS_WARNING_ID.UnHandle },
  { name: "Đã xử lý", id: STATUS_WARNING_ID.Handled },
];

// export const CATEGORY_NOTI_ID = {
//   Warning: "1",
// };

export const TYPE_VALUE_VOUCHER = {
  Money: 1,
  Percent: 2,
};

export const STATUS_VOUCHER_TICKET_ID = {
  Unsaved: 0,
  Saved: 1,
  Actived: 2,
};
export const STATUS_VOUCHER_TICKET = [
  { value: STATUS_VOUCHER_TICKET_ID.Unsaved, title: "Chưa lưu", color: "red" },
  { value: STATUS_VOUCHER_TICKET_ID.Saved, title: "Đã lưu", color: "blue" },
  {
    value: STATUS_VOUCHER_TICKET_ID.Actived,
    title: "Đã sử dụng",
    color: "green",
  },
];

export const STATUS_ORDER_MERGE = [
  {
    title: "Đang tìm xe",
    id: 1,
    value: [
      STATUS_ORDER_ID.FindingDriver,
      STATUS_ORDER_ID.FindingDriverRound,
      STATUS_ORDER_ID.DriverConfirming,
    ],
    color: "#00e138",
  },
  {
    title: "Đi đón khách",
    id: 2,
    value: [STATUS_ORDER_ID.DriverConfirmed, STATUS_ORDER_ID.DriverComeIn],
    color: "yellow",
  },
  {
    title: "Hoàn thành chuyến",
    id: 9,
    value: [STATUS_ORDER_ID.Completed],
    color: "blue",
  },
  {
    title: "Đang chở khách",
    id: 4,
    value: [STATUS_ORDER_ID.Started],
    color: "#fa5e29",
  },
  {
    title: "Khách hủy chuyến",
    id: 5,
    value: [STATUS_ORDER_ID.CustomerCanceled],
    color: "red",
  },
  {
    title: "Tài xế hủy chuyến",
    id: 6,
    value: [STATUS_ORDER_ID.DriverCancel],
    color: "volcano",
  },
  {
    title: "Không tìm được tài",
    id: 7,
    value: [STATUS_ORDER_ID.RequestTimeout],
    color: "volcano",
  },
  {
    title: "Điều hành hủy chuyến",
    id: 8,
    value: [STATUS_ORDER_ID.OperatorCancel],
    color: "red",
  },
];

export const STATUS_ORDER_TYPE_MERGE = [
  { title: "Chuyến có điểm đến", id: 1, value: [ORDER_TYPE_ID.PointToPoint] },
  // { title: "City Tour", id: 2, value: [ORDER_TYPE_ID.CityTour] },
  {
    title: "Khách vãng lai",
    id: 3,
    value: [ORDER_TYPE_ID.ExternalRequest, ORDER_TYPE_ID.QuickOrder],
  },
];
export const REPORT_FILTER_TIME_ID = {
  Today: 5,
  Yesterday: 1,
  Past7Days: 2,
  Past30Days: 3,
  Past1Year: 4,
};

export const REPORT_FILTER_TIME = [
  { value: REPORT_FILTER_TIME_ID.Yesterday, title: "Hôm qua" },
  { value: REPORT_FILTER_TIME_ID.Today, title: "Hôm nay" },
  { value: REPORT_FILTER_TIME_ID.Past7Days, title: "7 ngày qua" },
  { value: REPORT_FILTER_TIME_ID.Past30Days, title: "30 ngày qua" },
  { value: REPORT_FILTER_TIME_ID.Past1Year, title: "1 năm qua" },
];

export const ChartOptionType = {
  LINE: "line",
  BAR: "bar",
};

export const MAP_TYPE = {
  GOOGLE: 0,
  OPENSTREET: 1,
  BING: 2,
  MAPBOX: 3,
};

export const METHOD_TYPE = {
  FIREBASE: 0,
  ZALO: 1,
  EMAIL: 2,
};

export const CONTRACT_TYPE = {
  PROBATION: 0,
  OFFICIAL: 1,
  COLLABORATOR: 2,
};

export const CONTRACT_TYPE_OPTIONS = [
  {
    value: CONTRACT_TYPE.PROBATION,
    label: "Thử việc",
    color: "#f59e0b",
    bg: "#fef3c7",
  },
  {
    value: CONTRACT_TYPE.OFFICIAL,
    label: "Chính thức",
    color: "#16a34a",
    bg: "#dcfce7",
  },
  {
    value: CONTRACT_TYPE.COLLABORATOR,
    label: "Cộng tác viên",
    color: "#2563eb",
    bg: "#dbeafe",
  },
];

export const DRIVER_STATUS = {
  WORKING: 1,
  SUSPENDED: 2,
  RESIGNED: 3,
};

export const DRIVER_STATUS_OPTIONS = [
  {
    value: DRIVER_STATUS.WORKING,
    label: "Đang làm việc",
    color: "#16a34a",
    bg: "#dcfce7",
  },
  {
    value: DRIVER_STATUS.SUSPENDED,
    label: "Tạm ngưng",
    color: "#f59e0b",
    bg: "#fef3c7",
  },
  {
    value: DRIVER_STATUS.RESIGNED,
    label: "Nghỉ việc",
    color: "#6b7280",
    bg: "#f3f4f6",
  },
];

export const VEHICLE_ORDER_STATUS = {
  AVAILABLE: 0,
  DISPATCHING: 1,
  PICKING_UP: 2,
  ON_TRIP: 3,
  BUSY: 4,
  UNDER_MAINTENANCE: 5,
  INACTIVE: 6,
};

// export const VEHICLE_ORDER_STATUS_OPTIONS = [
//   {
//     value: VEHICLE_ORDER_STATUS.AVAILABLE,
//     label: "Sẵn sàng",
//   },
//   {
//     value: VEHICLE_ORDER_STATUS.DISPATCHING,
//     label: "Đang điều phối",
//   },
//   {
//     value: VEHICLE_ORDER_STATUS.PICKING_UP,
//     label: "Đang đón khách",
//   },
//   {
//     value: VEHICLE_ORDER_STATUS.ON_TRIP,
//     label: "Đang thực hiện chuyến",
//   },
//   {
//     value: VEHICLE_ORDER_STATUS.BUSY,
//     label: "Đang bận",
//   },
//   {
//     value: VEHICLE_ORDER_STATUS.UNDER_MAINTENANCE,
//     label: "Bảo dưỡng",
//   },
//   {
//     value: VEHICLE_ORDER_STATUS.INACTIVE,
//     label: "Ngừng hoạt động",
//   },
// ];

export const VEHICLE_STATUS = {
  Available: 0,
  OnTrip: 1,
  UnderMaintenance: 2,
  Inactive: 3,
};

export const VEHICLE_STATUS_OPTIONS = [
  {
    value: VEHICLE_STATUS.Available,
    label: "Sẵn sàng",
    color: "#16a34a",
    bg: "#dcfce7",
    dot: "#16a34a",
  },
  {
    value: VEHICLE_STATUS.OnTrip,
    label: "Đang chạy",
    color: "#2563eb",
    bg: "#dbeafe",
    dot: "#2563eb",
  },
  {
    value: VEHICLE_STATUS.UnderMaintenance,
    label: "Bảo dưỡng",
    color: "#f59e0b",
    bg: "#fef3c7",
    dot: "#f59e0b",
  },
  {
    value: VEHICLE_STATUS.Inactive,
    label: "Ngừng hoạt động",
    color: "#6b7280",
    bg: "#f3f4f6",
    dot: "#9ca3af",
  },
];

export const VEHICLE_CLASS = {
  STANDARD: 0,
  PREMIUM: 1,
  VIP: 2,
};

export const VEHICLE_CLASS_OPTIONS = [
  {
    value: VEHICLE_CLASS.STANDARD,
    label: "Standard",
    color: "#6b7280",
    bg: "#f3f4f6",
  },
  {
    value: VEHICLE_CLASS.PREMIUM,
    label: "Premium",
    color: "#2563eb",
    bg: "#dbeafe",
  },
  {
    value: VEHICLE_CLASS.VIP,
    label: "VIP",
    color: "#7c3aed",
    bg: "#ede9fe",
  },
];

export const VEHICLE_CATEGORY = {
  ELECTRIC: 0,
  GASOLINE: 1,
};

export const VEHICLE_CATEGORY_OPTIONS = [
  {
    value: VEHICLE_CATEGORY.ELECTRIC,
    label: "Xe điện",
    color: "#16a34a",
    bg: "#dcfce7",
    dot: "#16a34a",
  },
  {
    value: VEHICLE_CATEGORY.GASOLINE,
    label: "Xe xăng",
    color: "#f59e0b",
    bg: "#fef3c7",
    dot: "#f59e0b",
  },
];

export const WORKING_AREA_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
};

export const WORKING_AREA_STATUS_OPTIONS = [
  {
    value: WORKING_AREA_STATUS.ACTIVE,
    label: "Hoạt động",
    color: "#16a34a",
    bg: "#dcfce7",
    dot: "#16a34a",
  },
  {
    value: WORKING_AREA_STATUS.INACTIVE,
    label: "Tạm dừng",
    color: "#f59e0b",
    bg: "#fef3c7",
    dot: "#f59e0b",
  },
];

export const PRICING_TYPE = {
  FIXED: 1,
  PER_UNIT: 2,
  PER_TIME: 3,
};

export const PRICING_TYPE_OPTIONS = [
  {
    value: PRICING_TYPE.FIXED,
    label: "Phí cố định — tính 1 lần / chuyến",
    color: "#3e79f7",
    bg: "#eff6ff",
  },
  {
    value: PRICING_TYPE.PER_UNIT,
    label: "Theo số lượng — khách nhập số lượng",
    color: "#ff8a00",
    bg: "#fffbeb",
  },
  {
    value: PRICING_TYPE.PER_TIME,
    label: "Theo thời gian — tính theo phút",
    color: "#0072d2",
    bg: "#eff6ff",
  },
];

export const APPLY_TYPE = {
  PICKUP: 0,
  DROP_OFF: 1,
  BOTH: 2,
};

export const APPLY_TYPE_OPTIONS = [
  {
    value: APPLY_TYPE.PICKUP,
    label: "Đón tại sân bay",
    color: "#3e79f7",
    bg: "#eff6ff",
  },
  {
    value: APPLY_TYPE.DROP_OFF,
    label: "Trả tại sân bay",
    color: "#ff8a00",
    bg: "#fffbeb",
  },
  {
    value: APPLY_TYPE.BOTH,
    label: "Cả đón và trả",
    color: "#0072d2",
    bg: "#eff6ff",
  },
];

export const TOLL_ROUTE_APPLY = {
  BOTH: 1,
  ONE_WAY: 2,
};

export const TOLL_ROUTE_APPLY_OPTION = [
  {
    value: TOLL_ROUTE_APPLY.ONE_WAY,
    label: "1 chiều",
    color: "#3e79f7",
    bg: "#eff6ff",
  },
  {
    value: TOLL_ROUTE_APPLY.BOTH,
    label: "Cả 2 chiều",
    color: "#ff8a00",
    bg: "#fffbeb",
  },
];

export const TOLL_LOCATION_TYPE = {
  PROVINCE: 1,
  WORKING_AREA: 2,
};

export const TYPE_TRIP = {
  ONE_WAY: 1,
  ROUND_TRIP: 2,
};

export const APPROVAL_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const APPROVAL_STATUS_OPTIONS = [
  {
    value: APPROVAL_STATUS.PENDING,
    label: "Chờ duyệt",
    color: "#f59e0b",
    bg: "#fffbeb",
    border: "#e5e7eb",
    icon: <ClockCircleOutlined />,
  },
  {
    value: APPROVAL_STATUS.APPROVED,
    label: "Đã duyệt",
    color: "#3e79f7",
    bg: "#eff6ff",
    border: "#e5e7eb",
    icon: <CheckCircleFilled />,
  },
  {
    value: APPROVAL_STATUS.REJECTED,
    label: "Từ chối",
    color: "#dc2626",
    bg: "#fef2f2",
    border: "#e5e7eb",
    icon: <CloseCircleFilled />,
  },
];

export const PAYMENT_EXPENSE_STATUS = {
  UNPAID: 1,
  PAID: 2,
};

export const PAYMENT_EXPENSE_STATUS_OPTIONS = [
  {
    value: PAYMENT_EXPENSE_STATUS.UNPAID,
    label: "Chưa thanh toán",
    color: "#ff8a00",
    bg: "#fffbeb",
  },
  {
    value: PAYMENT_EXPENSE_STATUS.PAID,
    label: "Đã thanh toán",
    color: "#52c41a",
    bg: "#f6ffed",
  },
];

export const PAYMENT_METHOD = {
  CASH: 1,
  BANK_TRANSFER: 2,
};

export const PAYMENT_METHOD_OPTIONS = [
  {
    value: PAYMENT_METHOD.CASH,
    label: "Tiền mặt",
    icon: "💵",
    color: "#16a34a",
    bg: "#f0fdf4",
    border: "#e5e7eb",
  },
  {
    value: PAYMENT_METHOD.BANK_TRANSFER,
    label: "Chuyển khoản",
    icon: "🏦",
    color: "#0072d2",
    bg: "#eff6ff",
    border: "#e5e7eb",
  },
];

export const VEHICLE_EXPENSE_ROLE = {
  DRIVER: 1,
  MANAGER: 2,
};

export const VEHICLE_EXPENSE_ROLE_OPTION = [
  {
    value: VEHICLE_EXPENSE_ROLE.DRIVER,
    label: "Tài xế",
  },
  {
    value: VEHICLE_EXPENSE_ROLE.MANAGER,
    label: "Quản lý",
  },
];

export const SHIFT_STATUS = {
  ASSIGNED: 1,
  NOT_ASSIGNED: 2,
  PARTIAL_ASSIGNED: 3,
};

export const SHIFT_STATUS_OPTIONS = [
  {
    value: SHIFT_STATUS.NOT_ASSIGNED,
    label: "Chưa phân ca",
    color: "#ef4444",
    background: "#fee2e2",
  },
  {
    value: SHIFT_STATUS.PARTIAL_ASSIGNED,
    label: "Phân ca một phần",
    color: "#f59e0b",
    background: "#fef3c7",
  },
  {
    value: SHIFT_STATUS.ASSIGNED,
    label: "Đã phân ca",
    color: "#22c55e",
    background: "#dcfce7",
  },
];

export const SYSTEM_STATUS_SHIFTS_DRIVER = [
  {
    name: "Chưa phân xe",
    id: SHIFT_STATUS.NOT_ASSIGNED,
    className: "ant-tag-red",
  },
  {
    name: "Phân một phần",
    id: SHIFT_STATUS.PARTIAL_ASSIGNED,
    className: "ant-tag-orange",
  },
  {
    name: "Đã phân xe",
    id: SHIFT_STATUS.ASSIGNED,
    className: "ant-tag-green",
  },
];

export const SHIFT_NUMBER = {
  SHIFT_1: 1,
  SHIFT_2: 2,
  SHIFT_3: 3,
};

export const SHIFT_NUMBER_OPTIONS = [
  {
    value: SHIFT_NUMBER.SHIFT_1,
    label: "Ca 1",
    color: "#0072d2",
    background: "#eff6ff",
  },
  {
    value: SHIFT_NUMBER.SHIFT_2,
    label: "Ca 2",
    color: "#7c3aed",
    background: "#f3e8ff",
  },
  {
    value: SHIFT_NUMBER.SHIFT_3,
    label: "Ca 3",
    color: "#0891b2",
    background: "#cffafe",
  },
];

export const PAGE_SIZE = 20;
export const PAGE_INDEX = 1;

export const E_BOOKING_ORDER_STATUS = {
  CONFIRMED: 1,
  FULLY_ASSIGNED: 2,
  RUNNING: 3,
  COMPLETED: 4,
  CANCELLED: 5,
};

export const E_BOOKING_ORDER_STATUS_OPTION = [
  {
    value: E_BOOKING_ORDER_STATUS.CONFIRMED,
    label: "Chưa đủ tài",
    color: "warning",
    hex: "#f59e0b",
    bg: "#fffbeb",
  },
  {
    value: E_BOOKING_ORDER_STATUS.FULLY_ASSIGNED,
    label: "Đã gán đủ",
    color: "blue",
    hex: "#0072d2",
    bg: "#eff6ff",
  },
  {
    value: E_BOOKING_ORDER_STATUS.RUNNING,
    label: "Đang chạy",
    color: "processing",
    hex: "#2563eb",
    bg: "#eff6ff",
  },
  {
    value: E_BOOKING_ORDER_STATUS.COMPLETED,
    label: "Hoàn tất",
    color: "success",
    hex: "#16a34a",
    bg: "#f0fdf4",
  },
  {
    value: E_BOOKING_ORDER_STATUS.CANCELLED,
    label: "Đã hủy",
    color: "error",
    hex: "#dc2626",
    bg: "#fef2f2",
  },
];

export const STATUS_META = {
  // Chờ tài
  0: {
    group: "Chờ tài",
    subLabel: "Chờ điều phối",
    color: "#f59e0b",
    bg: "#fef3c7",
    critical: true,
  },
  1: {
    group: "Chờ tài",
    subLabel: "Đang tìm (gđ1)",
    color: "#f59e0b",
    bg: "#fef3c7",
    critical: true,
  },
  2: {
    group: "Chờ tài",
    subLabel: "Đang tìm (gđ2)",
    color: "#f59e0b",
    bg: "#fef3c7",
    critical: true,
  },
  3: {
    group: "Chờ tài",
    subLabel: "Điều phối thủ công",
    color: "#f59e0b",
    bg: "#fef3c7",
    critical: true,
  },
  4: {
    group: "Chờ tài",
    subLabel: "Chờ tài xác nhận",
    color: "#f59e0b",
    bg: "#fef3c7",
    critical: true,
  },
  // Đang chạy
  5: {
    group: "Đang chạy",
    subLabel: "Tài xế đã nhận",
    color: "#3e79f7",
    bg: "#eff6ff",
    critical: false,
  },
  6: {
    group: "Đang chạy",
    subLabel: "Tài xế đang đến",
    color: "#3e79f7",
    bg: "#eff6ff",
    critical: false,
  },
  7: {
    group: "Đang chạy",
    subLabel: "Tài xế đã đến điểm",
    color: "#3e79f7",
    bg: "#eff6ff",
    critical: false,
  },
  8: {
    group: "Đang chạy",
    subLabel: "Đang thực hiện",
    color: "#3e79f7",
    bg: "#eff6ff",
    critical: false,
  },
  // Hoàn thành
  9: {
    group: "Hoàn thành",
    subLabel: null,
    color: "#16a34a",
    bg: "#dcfce7",
    critical: false,
  },
  // Hủy chuyến
  10: {
    group: "Hủy chuyến",
    subLabel: "Tài xế hủy",
    color: "#dc2626",
    bg: "#fef2f2",
    critical: true,
  },
  15: {
    group: "Hủy chuyến",
    subLabel: "Điều hành hủy",
    color: "#dc2626",
    bg: "#fef2f2",
    critical: true,
  },
  // Không tìm được tài
  20: {
    group: "Không tìm được tài",
    subLabel: "Hết thời gian",
    color: "#7c3aed",
    bg: "#f5f3ff",
    critical: true,
  },
};

export const TRIP_STATUS_OPTIONS = [
  { value: "all", label: "Mọi trạng thái" },
  {
    label: "Chờ tài",
    options: [
      { value: 0, label: "Chờ điều phối", bg: "#fff7ed", color: "#ea580c" },
      { value: 1, label: "Đang tìm (gđ1)", bg: "#fff7ed", color: "#ea580c" },
      { value: 2, label: "Đang tìm (gđ2)", bg: "#fff7ed", color: "#ea580c" },
      {
        value: 3,
        label: "Điều phối thủ công",
        bg: "#fef3c7",
        color: "#d97706",
      },
      { value: 4, label: "Chờ tài xác nhận", bg: "#fef3c7", color: "#d97706" },
    ],
  },
  {
    label: "Đang chạy",
    options: [
      { value: 5, label: "Tài xế đã nhận", bg: "#dbeafe", color: "#2563eb" },
      { value: 6, label: "Tài xế đang đến", bg: "#dbeafe", color: "#2563eb" },
      { value: 7, label: "Đã đến điểm", bg: "#dbeafe", color: "#2563eb" },
      { value: 8, label: "Đang thực hiện", bg: "#dcfce7", color: "#16a34a" },
    ],
  },
  {
    label: "Hoàn thành",
    options: [
      { value: 9, label: "Hoàn thành", bg: "#dcfce7", color: "#15803d" },
    ],
  },
  {
    label: "Hủy chuyến",
    options: [
      { value: 10, label: "Tài xế hủy", bg: "#fee2e2", color: "#dc2626" },
      { value: 15, label: "Điều hành hủy", bg: "#fee2e2", color: "#dc2626" },
    ],
  },
  {
    label: "Không tìm được tài",
    options: [
      { value: 20, label: "Hết thời gian", bg: "#f3f4f6", color: "#6b7280" },
    ],
  },
];

export const TRIP_TYPE_OPTIONS = [
  { value: "all", label: "Mọi loại chuyến" },
  { value: 1, label: "Một chiều" },
  { value: 2, label: "Khứ hồi" },
];

export const DATE_OPTIONS = [
  { value: "today", label: "Hôm nay" },
  { value: "yesterday", label: "Hôm qua" },
  { value: "last7", label: "7 ngày" },
  { value: "last30", label: "30 ngày" },
  { value: "custom", label: "Tùy chọn" },
];

export const EPaymentStatusFilter = {
  Unpaid: 0,
  PartiallyPaid: 1,
  Paid: 2,
};

export const PAYMENT_STATUS_OPTIONS = [
  { value: "all", label: "Mọi trạng thái thanh toán" },
  { value: EPaymentStatusFilter.Unpaid, label: "Chưa thanh toán" },
  { value: EPaymentStatusFilter.PartiallyPaid, label: "Thanh toán một phần" },
  { value: EPaymentStatusFilter.Paid, label: "Đã thanh toán" },
];

export const STATUS_TABS = [
  { key: "confirmed", value: 1, label: "Chưa đủ tài", hex: "#f59e0b" },
  { key: "fullyAssigned", value: 2, label: "Đã gán đủ", hex: "#0072d2" },
  { key: "running", value: 3, label: "Đang chạy", hex: "#2563eb" },
  { key: "completed", value: 4, label: "Hoàn tất", hex: "#16a34a" },
  { key: "cancelled", value: 5, label: "Đã hủy", hex: "#dc2626" },
];

export const NOTIFICATION_TYPE = {
  Warning: 1,
  System: 2,
  Trip: 3,
  Order: 4,
  VehicleExpense: 5,
};

export const ZONE_LOCATION_TYPE = {
  PROVINCE: 1,
  WARD: 4,
};

export const ZONE_APPLY_FOR = {
  BOTH: 1,
  PICKUP: 2,
  DROPOFF: 3,
};

export const ZONE_APPLY_FOR_OPTIONS = [
  { value: ZONE_APPLY_FOR.BOTH, label: "Cả 2 chiều" },
  { value: ZONE_APPLY_FOR.PICKUP, label: "Sân bay → Nội thành" },
  { value: ZONE_APPLY_FOR.DROPOFF, label: "Nội thành → Sân bay" },
];

export const ZONE_APPLY_FOR_STYLE = {
  [ZONE_APPLY_FOR.BOTH]: { bg: "#eff6ff", color: "#1d4ed8" },
  [ZONE_APPLY_FOR.PICKUP]: { bg: "#f0fdf4", color: "#15803d" },
  [ZONE_APPLY_FOR.DROPOFF]: { bg: "#fef3c7", color: "#b45309" },
};

export const PRICING_METHOD = {
  DISTANCE: 1,
  ZONE: 2,
  RADIUS: 3,
};

export const LEG = {
  OUTBOUND: 1,
  RETURN: 2,
};